import { HiOutlineCube } from "react-icons/hi";
import { FiRefreshCw } from "react-icons/fi";
import styles from "./GenerateKit.module.css";
import { KitCard } from "./KitCard";

const OPTION_LABELS = ["Option A", "Option B", "Option C"];

export const KitPreview = ({
  kits = [],
  budget = 0,
  productSplit,
  onReplace,
  onRegenerate,
  loading = false,
}) => {
  const hasKits = Array.isArray(kits) && kits.length > 0;

  if (!hasKits) {
    return (
      <div className={`${styles.rightSection} ${styles.rightSectionEmpty}`}>
        <h2 className={styles.sectionTitle}>Kit Preview</h2>
        <HiOutlineCube className={styles.previewIcon} />
        <p className={styles.previewText}>
          Fill in the form to generate curated kit options. The system will
          automatically optimize product combinations based on your budget and
          requirements.
        </p>
      </div>
    );
  }

  return (
    <div className={`${styles.rightSection} ${styles.rightSectionWithKits}`}>
      <div className={styles.kitOptionsHeader}>
        <h2 className={styles.sectionTitle}>Kit Options</h2>
        <button
          type="button"
          className={styles.regenerateButton}
          onClick={onRegenerate}
          disabled={loading}
        >
          <FiRefreshCw className={styles.regenerateIcon} />
          Regenerate
        </button>
      </div>
      <div className={styles.kitCardsGrid}>
        {kits.map((kit, kitIndex) => (
          <KitCard
            key={kitIndex}
            kit={kit}
            kitIndex={kitIndex}
            optionLabel={OPTION_LABELS[kitIndex] ?? `Option ${kitIndex + 1}`}
            budget={budget}
            productSplit={productSplit}
            onReplace={onReplace}
          />
        ))}
      </div>
    </div>
  );
};
